import { Stack, useMediaQuery } from "@mui/material";

import { ShipperUpgradeNowButton } from "components/Shipper/components/ShipperUpgradeNowButton/ShipperUpgradeNowButton";

import { BANNER_TEXT_MIN_WIDTH } from "../../constants";
import { ShipperTrialDaysRemainingText } from "../ShipperTrialDaysRemainingText";

export function TrialShipperBanner() {
  const showText = useMediaQuery(BANNER_TEXT_MIN_WIDTH);

  return (
    <Stack direction="row" spacing={4} alignItems="center">
      {showText && <ShipperTrialDaysRemainingText />}
      <ShipperUpgradeNowButton
        buttonSize="large"
        trackingSource="trial_banner"
      />
    </Stack>
  );
}
